// eslint-disable-next-line max-len
const addSimpleOpacityAnimation = (timeline, box, start = 0.1, durationNumber = 0.3, staggerNumber = 0.15) => {
    timeline.fromTo(box, { opacity: '0' }, {
        opacity: '1', duration: durationNumber, stagger: staggerNumber, ease: 'ease-out',
    }, `start+=${start}`);
};

export default addSimpleOpacityAnimation;
